import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	button: {
		alignItems: "center",
		border: "1px solid " + theme.palette.grey[50],
		color: "#FFFFFF",
		cursor: "pointer",
		display: "none",
		height: 48,
		justifyContent: "center",
		position: "absolute",
		top: 24,
		right: 24,
		width: 48,
		zIndex: 1,
		"& svg path": {
			fill: theme.palette.grey[50]
		},
		[theme.breakpoints.up("md")]: {
			display: "flex"
		}
	}
}));

export default styles;
